import { useEffect, useState } from 'react';
import { FaSpinner } from "react-icons/fa";
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Container, Input, Row } from 'reactstrap';
import {
    loadingToggleAction, loginAction,
} from '../../../store/actions/AuthActions';
import { translate } from '../../../utils/translate';
import AuthHeader from '../../layouts/nav/AuthHeader';
import "../../../css/auth.scss";

function Login(props) {
    let errorsObj = { username: '', password: '' };
    const [errors, setErrors] = useState(errorsObj);
    const [rememberMe, setRememberMe] = useState(true);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [username, setUsername] = useState('');

    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(loadingToggleAction(false))
    },[])

    function onLogin() {
        let check = true;
        const errorObj = { ...errorsObj };
        if (!username) {
            errorObj.username = 'This field is required.';
            check = false;
        }
        if (!password) {
            errorObj.password = 'This field is required.';
            check = false;
        }
        setErrors(errorObj);
        if (check) {
            let data = {
                username: username,
                password: password,
                rememberMe: rememberMe
            }
            dispatch(loadingToggleAction(true));
            dispatch(loginAction(data, props.history, props.lang));
        }
    }

    const onChangeCheckbox = (e) => {
        setRememberMe(e.target.checked)
    }

    const onHandleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onLogin();
        }
    }
    return (
        <>
            <div className='login min-vh-100'>
                <AuthHeader logoColor={'blue'} />
                <div className={`authincation d-flex flex-column flex-lg-row flex-column-fluid h-100  pt-lg-0`}>
                    <div className="w-100 min-vh-100 d-flex align-items-center justify-content-center">
                        <Container className='h-100'>
                            <Row className="h-100 align-items-center justify-content-center pt-2 mx-0 px-0">
                                <Col lg={10} md={12} sm={12} xs={12}>
                                    <Row className='px-0 mx-0 align-items-center justify-content-center'>
                                        <Col lg={4} md={6} sm={8} xs={8} className='mb-md-5 mb-3'>
                                            <div className='text-center'>
                                                <img src={require('../../../images/logo/logo.png').default} alt="logo" className='img-fluid' />
                                            </div>
                                        </Col>
                                    </Row>
                                   
                                    <div className='whiteContainer px-3 py-5 p-md-5'>
                                        <div className="d-flex flex-column-auto flex-column">
                                            <div className="text-center">
                                                <span className={`font-weight-600 font-32 text-black-1 text-capitalize`}>{translate(props.lang, "Admin Login")}</span>
                                            </div>
                                        </div>
                                        <div className="mt-5">
                                            <div className={`groupLabel-input py-1 mb-1 ${errors.username ? 'errorBorder' : ''}`}>
                                                <span className={`font-weight-500 px-md-4 px-3 font-13 text-grey-1 d-block mt-2`}>{translate(props.lang, "Username")} <span className='text-red'>*</span></span>
                                                <div className={`input-group `}>
                                                    <Input
                                                        type="text"
                                                        name="username"
                                                        placeholder={translate(props.lang, "Enter Username")}
                                                        className="form-control input-transparent py-1 px-md-4 px-3"
                                                        autoComplete="off"
                                                        onChange={e => setUsername(e.target.value.toLowerCase().trim())}
                                                        onKeyDown={(e) => onHandleKeyDown(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='ms-4'>
                                                <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.username)}</span>
                                            </div>
                                        </div>
                                        <div className="mt-4">
                                            <div className={`groupLabel-input py-1 mb-1 ${errors.password ? 'errorBorder' : ''}`}>
                                                <span className={`font-weight-500 px-md-4 px-3 font-13 text-grey-1 d-block mt-2`}>{translate(props.lang, "Password")} <span className='text-red'>*</span></span>
                                                <div className={`input-group`}>
                                                    <Input
                                                        type={showPassword ? "text" : "password"}
                                                        name="password"
                                                        placeholder={translate(props.lang, "Enter Password")}
                                                        className="form-control input-transparent py-1 px-md-4 px-3"
                                                        autoComplete="off"
                                                        onChange={e => setPassword(e.target.value)}
                                                        onKeyDown={(e) => onHandleKeyDown(e)}
                                                    />
                                                    <div className='d-flex align-items-center justify-content-end transparent-bg pe-3 pe-md-4' onClick={() => setShowPassword(!showPassword)}>
                                                        {showPassword ? (
                                                            <img src={require('../../../images/icon/eyeSlash.svg').default} className="img-fluid" alt="icon" />
                                                        ) : (
                                                            <img src={require('../../../images/icon/eye.svg').default} className="img-fluid" alt="icon" />
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                            <div className='ms-4'>
                                                <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.password)}</span>
                                            </div>
                                        </div>
                                        <Row className='justify-content-start align-items-center mx-lg-3 mx-1 mt-2 px-0 mx-0'>
                                            <Col lg={6} md={6} sm={6} xs={6} className="text-start px-0 mx-0">
                                                <div className="form-check custom-checkbox d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input rememberMe-checkbox"
                                                        id="customCheckBox1"
                                                        checked={rememberMe}
                                                        onChange={(e) => onChangeCheckbox(e)}
                                                    />
                                                    <label
                                                        className={`form-check-label font-weight-500 font-13 text-grey-8 float-start mb-0`}
                                                        htmlFor="customCheckBox1"
                                                    >
                                                        {translate(props.lang, "Remember me")}
                                                    </label>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-start mt-3 mx-0 px-0">
                                            <Col lg={12} md={12} sm={12} xs={12} className="my-2 px-0 mx-0">
                                                <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => onLogin()} disabled={props.showLoading}>
                                                    <span className={`font-weight-600 font-20 line-height-30 text-white`}>{props.showLoading ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Login")}</span>
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const { i18n } = state;
    return {
        errorMessage: state.auth.errorMessage,
        successMessage: state.auth.successMessage,
        showLoading: state.auth.showLoading,
        lang: i18n.lang,
    };
};
export default withRouter(connect(mapStateToProps)(Login));
